import React from 'react';
import 'moment/locale/ru';
import moment from 'moment';
import {RouterProvider} from 'react-router-dom';

import router from './navigation/routes';
import {usePages} from "./models/pages/pages-provider";
import LoadingPage from "./pages/loading/loading.page";
import {useRecords} from './models/records/records-provider';
moment.locale('ru');

function App() {
  const {
    data,
    isLoading,
  } = usePages();
  const {
    isLoading: recordsIsLoading,
  } = useRecords();

  if (isLoading || recordsIsLoading) {
    return <LoadingPage/>;
  }

  return <RouterProvider router={router(data!)} />;
}

export default App;
